'use client';
2;
import { PrimaryButtonMT, RoundButton, SecondaryButton, SecondaryButtonMT } from '@/components/buttons/Buttons';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import ApprovedPeopleTable from '../components/ApprovedPeopleTable';
import AwaitingApprovalPeopleTable from '../components/AwaitingApprovalPeopleTable';

interface People2 {
	name: string;
	requestDate: string;
	phoneNumber: string;
	status: string;
}

const forApprovalEmployees: People2[] = [
	{
		name: 'Michelle Chang',
		requestDate: '05/16/2024',
		phoneNumber: '+639567319926',
		status: 'For Approval',
	},
	{
		name: 'Marshall Law',
		requestDate: '05/16/2024',
		phoneNumber: '+639567319926',
		status: 'For Approval',
	},
	{
		name: 'Miharu Hirano',
		requestDate: '05/16/2024',
		phoneNumber: '+639567319926',
		status: 'For Approval',
	},
	{
		name: 'Bruce Irvin',
		requestDate: '05/16/2024',
		phoneNumber: '+639567319926',
		status: 'For Approval',
	},
	{
		name: 'Claudio Serafino',
		requestDate: '05/16/2024',
		phoneNumber: '+639567319926',
		status: 'For Approval',
	},
	{
		name: 'Craig Marduk',
		requestDate: '05/16/2024',
		phoneNumber: '+639567319926',
		status: 'For Approval',
	},
	{
		name: 'Julia Chang',
		requestDate: '05/16/2024',
		phoneNumber: '+639567319926',
		status: 'For Approval',
	},
	{
		name: 'Lars Alexandersson',
		requestDate: '05/16/2024',
		phoneNumber: '+639567319926',
		status: 'For Approval',
	},
	{
		name: 'Lei Wulong',
		requestDate: '05/16/2024',
		phoneNumber: '+639567319926',
		status: 'For Approval',
	},
	{
		name: 'Leroy Smith',
		requestDate: '05/16/2024',
		phoneNumber: '+639567319926',
		status: 'For Approval',
	},
];

type status = 'approved' | 'awaiting';

const ListPeopleScreen = () => {
	// const [approvedPeople, setApprovePeople] =
	// 	useState<ApprovedPeople[]>([]);
	const [forApprovalPeople, setForApprovalPeople] =
		useState<People2[]>(forApprovalEmployees);



	const [activeTab, setActiveTab] = useState<status>('approved');

	return (
		<div>
			<div className="flex gap-3 mb-5">
				{activeTab === 'approved' ? (<PrimaryButtonMT
					id="approved"
					label="Approved"
					onClick={() => setActiveTab('approved')}
				/>) : (<SecondaryButtonMT
					id="approved"
					label="Approved"
					onClick={() => setActiveTab('approved')}
				/>)}
				{activeTab === 'awaiting' ? (<PrimaryButtonMT
					id="awaiting"
					label="Awaiting Approval"
					onClick={() => setActiveTab('awaiting')}
				/>) : (<SecondaryButtonMT
					id="awaiting"
					label="Awaiting Approval"
					onClick={() => setActiveTab('awaiting')}
				/>)}
			</div>
			{activeTab === 'approved' && (
				<ApprovedPeopleTable />
				// <ApprovedPeopleTable
				// 	people={approvedPeople??[]}
				// 	setPeople={setApprovePeople}
				// />
			)}
			{activeTab === 'awaiting' && (
				<AwaitingApprovalPeopleTable
					people={forApprovalPeople}
					setPeople={setForApprovalPeople}
				/>
			)}
		</div>
	);
};

export default ListPeopleScreen;
